export default __webpack_public_path__ + "static/media/Courier-New.c306e393.ttf";